import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { EnvironmentService } from '@services/environment.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'view-unit-intranet',
    templateUrl: './view-unit-intranet.component.html',
    styleUrls: ['./view-unit-intranet.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule]
})
export class ViewUnitIntranetComponent {
    private environmentService = inject(EnvironmentService);

    readonly internalId = input<string>(undefined);

    get viewUnitIntranetUrl(): string {
        return `${this.environmentService.getEnvinronment().intranetViewingUnitUrl}/${this.internalId()}`;
    }
}
